const developerEmails = new Set([
  "joel@survivalandflourishing.com",
  "peter@survivalandflourishing.com",
  "darby@survivalandflourishing.com",
  "pete@survivalandflourishing.com",
  "ethan@survivalandflourishing.com",
  "guilherme@ae.studio",
]);

export function isDeveloperEmail(email: string | null | undefined): boolean {
  return email != null && developerEmails.has(email.toLowerCase());
}
